import IKeyword from "../../../types/services/IKeyword";
import ISegment from "../../../types/services/ISegment";

export interface KeywordRow extends ISegment {
  createdOnStr: string;
  modifiedOnStr: string;
  keywordText: string;
  segmentLabel: string;
  linkedOrdinaryList?: boolean;
  targetSegmentId?: string;
}

function keywordTextFromId(keywordId: string, charityId: string): string {
  const prefix = `${charityId}-`;
  const text = keywordId.startsWith(prefix)
    ? keywordId.slice(prefix.length)
    : keywordId;
  return text.toUpperCase();
}

function segmentLabelFor(segment: KeywordRow): string {
  return segment.isKeyword ? `Keyword - ${segment.name}` : segment.name;
}

export function buildKeywordRows(
  segments: KeywordRow[],
  keywords: IKeyword[],
  charityId: string
): KeywordRow[] {
  const segmentsById = new Map(segments.map(segment => [segment.id, segment]));
  const representedDedicatedSegments = new Set<string>();
  const rows = keywords
    .filter(keyword => keyword.charityId === charityId)
    .map(keyword => {
      const segment = segmentsById.get(keyword.segmentId);
      if (!segment) return null;
      if (segment.isKeyword) representedDedicatedSegments.add(segment.id);
      return {
        ...segment,
        id: `smsKeyword:${keyword.id}`,
        name: segment.name,
        keywordText: keywordTextFromId(keyword.id, charityId),
        segmentLabel: segmentLabelFor(segment),
        linkedOrdinaryList: !segment.isKeyword,
        targetSegmentId: segment.id,
      };
    })
    .filter((segment): segment is KeywordRow => segment !== null);

  rows.push(
    ...segments
      .filter(
        segment =>
          segment.isKeyword && !representedDedicatedSegments.has(segment.id)
      )
      .map(segment => ({
        ...segment,
        keywordText: segment.name.toUpperCase(),
        segmentLabel: segmentLabelFor(segment),
      }))
  );
  return rows;
}
